module.exports = __webpack_public_path__ + "static/media/icons8-trash-can-28.3908e83b.svg";